import {
  LOAD_USER_FINISHED,
  LOAD_USER_TO_EDIT_FINISHED,
  LoadUserFinished, LoadUserToEditFinished,
  SAVE_USER_ERROR, SAVE_USER_TO_EDIT_FINISHED,
  SAVED_USER,
  SAVING_USER, SEARCH_USER_FINISHED, UPDATE_USER_TO_EDIT,
  UserActions
} from './user.actions';
import {FullUser} from '../model';

export interface UserToEdit extends FullUser {
  newBannerImageUrl?: string| ArrayBuffer;
  newBannerImageFile?: File;
  newImages?: Array<{src: string|ArrayBuffer, file: File}>;
}
export interface UserState {
  user: FullUser;
  saveError: string;
  users: {[key: string]: FullUser};
  loadError: '';
  userToEdit: UserToEdit;
  searchResult: FullUser[];
}
const initialState: UserState = {
  user: {displayName: ''},
  saveError: '',
  users: {},
  loadError: '',
  userToEdit: {displayName: ''},
  searchResult: []

};

export function reducer(state: UserState = initialState, action: UserActions) {
  switch (action.type) {
    case SAVED_USER:
      return Object.assign({}, state, {  user: action.payload, saveError: ''});
    case SAVING_USER:
        return Object.assign({}, state, {saveError: ''});
    case SAVE_USER_ERROR:
      return Object.assign({}, state, {saveError: action.payload} );
    case LOAD_USER_FINISHED:
      const user: FullUser = (action as LoadUserFinished).payload;
      return Object.assign({}, state,
        { users: {...state.users, [user.displayName] : user}});
    case LOAD_USER_TO_EDIT_FINISHED:
      const user1: FullUser = (action as LoadUserToEditFinished).payload;
      console.log('banner image is ', user1.bannerImage);
      return Object.assign({}, state, {userToEdit : createUserForEdit(user1)});
    case UPDATE_USER_TO_EDIT:
      console.log('updating user to edit', action.payload);
      return  Object.assign({}, state, {userToEdit: action.payload});
    case SAVE_USER_TO_EDIT_FINISHED:
        console.log('update user to edit finished');
        return Object.assign({}, state, {userToEdit: createUserForEdit(action.payload)});
    case SEARCH_USER_FINISHED:
      return Object.assign({}, state, {searchResult: action.payload})
    default:
      return  state;
  }
}

function createUserForEdit(user: FullUser): UserToEdit {
  console.log('user to edit is ', user);
  const banerImage =  (user.bannerImage !== undefined && user.bannerImage.url.length > 0 )
      ? user.bannerImage.url : './assets/img/sections/luke-chesser.jpg';
  const galleryImages = user.images ? user.images.map((img) => {
    return {src: img.url, file: null};
    }) : [];
  if ( !user.youtubes) {
    user.youtubes = [];
  }
  const result: UserToEdit = Object.assign({}, user, {newBannerImageUrl: banerImage, newBannerImageFile: null, newImages: galleryImages});
  return result;
}
